const PendingAR = () => {
  return (
    // <svg
    //   width={22}
    //   height={22}
    //   viewBox="0 0 24 24"
    //   fill="none"
    //   xmlns="http://www.w3.org/2000/svg"
    //   stroke={'#fff'}
    //   strokeWidth={1}
    //   strokeLinecap="round"
    //   strokeLinejoin="round"
    // >
    //   {/* Circular arrows */}
    //   <path d="M3 12a9 9 0 0 1 15.5-6.3" />
    //   <path d="M18.5 5.7L19 2.5l-3 .5" />

    //   <path d="M21 12a9 9 0 0 1-15.5 6.3" />
    //   <path d="M5.5 18.3L5 21.5l3-.5" />

    //   {/* Gear */}
    //   <circle cx="12" cy="12" r="4" />
    //   <path d="M12 2v2M12 20v2M2 12h2M20 12h2" />
    //   <path d="M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4" />
    //   <path d="M19.1 4.9l-1.4 1.4M6.3 17.7l-1.4 1.4" />

    //   {/* Clock hands */}
    //   <path d="M12 10v3l2 1" />
    // </svg>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width="20"
      height="20"
      x="0"
      y="0"
      viewBox="0 0 512.028 512.028"
    >
      <g>
        <path
          d="m505.692 441.34-99.307-172.09C448.734 138.965 345.48-2.359 207.816.03 93.053.028.018 93.063.018 207.827-1.1 333.703 114.686 432.954 238.811 413.324l-16.195 28.041c-8.322 14.513-8.322 32.544.047 47.137 8.44 14.511 24.091 23.525 40.843 23.525H464.9c16.821 0 32.458-9.045 40.761-23.525 8.471-14.562 8.471-32.655.031-47.162zm-282.874-56.349V374.92c-.738-19.881-29.269-19.866-30 0v10.071a176.697 176.697 0 0 1-60.608-16.208l5.052-8.753c4.142-7.175 1.683-16.348-5.492-20.49-7.174-4.14-16.349-1.684-20.49 5.493l-5.037 8.727a178.785 178.785 0 0 1-44.349-44.345l8.747-5.052c7.174-4.144 9.63-13.318 5.486-20.492-4.145-7.174-13.321-9.629-20.492-5.486l-8.766 5.063a176.696 176.696 0 0 1-16.215-60.622h10.07c19.881-.738 19.866-29.269 0-30h-10.07a176.696 176.696 0 0 1 16.214-60.621l8.766 5.064c7.174 4.143 16.348 1.688 20.492-5.486s1.688-16.348-5.486-20.492l-8.747-5.052a178.79 178.79 0 0 1 44.349-44.346l5.037 8.727c4.143 7.175 13.314 9.635 20.49 5.493 7.175-4.142 9.634-13.315 5.492-20.49l-5.052-8.753a176.662 176.662 0 0 1 60.608-16.208v10.071c.738 19.881 29.269 19.866 30 0v-10.07a176.697 176.697 0 0 1 60.608 16.208l-5.052 8.753c-4.142 7.175-1.683 16.348 5.492 20.49 7.174 4.141 16.348 1.684 20.49-5.493l5.037-8.727a178.769 178.769 0 0 1 44.349 44.345l-8.747 5.052c-7.174 4.144-9.63 13.318-5.486 20.492 4.145 7.174 13.32 9.629 20.492 5.486l8.766-5.063a176.697 176.697 0 0 1 16.215 60.621h-10.07c-19.881.738-19.866 29.269 0 30h10.07a177.549 177.549 0 0 1-3.623 23.798c-21.032-8.689-46.928.401-57.99 20.287l-64.202 111.165a176.996 176.996 0 0 1-36.348 6.914zm256.911 88.427-.094.161c-2.942 5.132-8.727 8.448-14.735 8.448H263.505c-6.077 0-11.764-3.265-14.863-8.527-3.027-5.343-3.03-11.929-.002-17.211l100.707-174.373c6.391-11.398 23.26-11.312 29.705-.008L479.76 456.424c3.039 5.224 3.027 11.736-.031 16.994z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
        <path
          d="M298.757 132.954c-5.857-5.858-15.355-5.858-21.213 0l-69.73 69.73-34.862-34.837c-5.859-5.855-15.357-5.853-21.213.007-5.855 5.86-5.853 15.357.008 21.213l45.469 45.437c5.858 5.855 15.353 5.852 21.209-.004l80.333-80.333c5.857-5.858 5.857-15.355-.001-21.213zM364.162 417.761c-8.284 0-15 6.716-15 15v8.033c.738 19.881 29.269 19.866 30 0v-8.033c0-8.284-6.716-15-15-15zM364.162 329.394c-8.284 0-15 6.716-15 15v33.29c.738 19.881 29.269 19.866 30 0v-33.29c0-8.284-6.716-15-15-15z"
          fill="#ffffff"
          opacity="1"
          data-original="#ffffff"
        ></path>
      </g>
    </svg>
  );
};
export default PendingAR;
